<template>
<v-layout :style="{'min-width': `${parentMinWidth}px`, 'min-height': `${parentMinHeight}px`}">
<v-layout ref="wrapper" :style="{'clear': 'both', 'position': 'absolute', 'min-width': '10000px','min-height': '10000px'}">
  <svg v-show="expanded" v-if="chart.reports && chart.reports.length > 0" id="lines" :ref="'lines' + id" 
  v-bind:style="{'position': 'absolute', 'min-width': `${(maxLinePointWidth + 200) * (1 / whichPageToShow)}px`, 'min-height': `${(maxLinePointHeight + 200) * (1 / whichPageToShow)}px`}"> </svg>
        <v-card @click="cardClicked" :style="{'height': orgCardHeight + 'px', 'width': orgCardWidth + 'px', 'left': `${parentLeftOffset}px` }" class="org-chart-user justify-center" :class="(isMoveInProgessSelected || parentMoving ? 'elevation-24' : '')"  justify-center ref='main'>
        <v-card-title :style="{'background-color': (chart.department === 'Engineering' ? 'rgba(200,0,0,0.2)' : (chart.department === 'Operations' ? 'rgba(0,0,200,0.2)' : (chart.department === 'Marketing' ? 'rgba(211, 84, 0, 0.2)' : (chart.department === 'Executive' ? 'rgba(249, 191, 59, 1)' : 'rgba(191, 191, 191, 0.8)')))), 'margin-bottom':'20px'}" class="justify-space-between">
          <v-avatar size="100" class="elevation-20" style="position: absolute; top:-75px; left: calc(50% - 50px); z-index:100">
            <v-img
            :src="chart.person ? chart.person.imageUrl : require('../assets/OpenPosition.jpg')"
            ></v-img>
          </v-avatar>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" v-if="id && (!moveInProgress || isMoveInProgessSelected)" width="50" height="50" style="position: absolute; top:25px; right: 75px; z-index:100" icon @click.stop="toggleMove">
                <v-icon v-if="isMoveInProgessSelected">fas fa-times-circle</v-icon>
                <v-icon v-else>fas fa-random</v-icon>
              </v-btn>
            </template>
            <span v-if="isMoveInProgessSelected">Cancel move</span>
            <span v-else>Move {{chart.person ? chart.person.firstName : 'this position'}} and everyone below</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" width="50" height="50" style="position: absolute; top:25px; right: 25px; z-index:100" icon @click.stop="() => functions.openPositionDialogWithReferer(indexArray)">
                <v-icon>fas fa-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Add a report below {{chart.person ? chart.person.firstName : 'this position'}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" v-if="chart.reports && chart.reports.length"  width="50" height="50" style="position: absolute; top:25px; right: 125px; z-index:100" icon @click.stop="toggleHorizontal">
                <v-icon>fas fa-sync</v-icon>
              </v-btn>
            </template>
            <span>Change {{chart.person ? chart.person.firstName : 'this position'}}'s direct reports to display {{chart.reportsHorizontal ? 'vertically' : 'horizontally'}}</span>
          </v-tooltip>
          <span  class="caption" style="position:absolute; right:10px; bottom:10px"><i>* indicates a custom field is only visible to administrators</i></span>
          <v-flex  column>
            <span v-if="chart.person"  class="title" style="display:block; margin-top:20px">{{chart.person.firstName}} {{chart.person.lastName}}</span>
              <span v-else  class="title" style="display:block; margin-top:20px">Open Position</span>
            <v-divider  />
            <span  class="subtitle-1">{{chart.jobTitle}}</span>
          </v-flex>
        </v-card-title>
        <v-flex column justify-center style="max-height: 90%;">
              <span v-if="chart.department" class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Department</b>: {{chart.department}}</span>
              <span v-if="chart.person"  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Hire Date</b>: {{chart.person.hireDate ? chart.person.hireDate.toLocaleDateString("en-US") : new Date(Math.random() * new Date().getTime()).toDateString()}}</span>
              <span v-if="chart.budgetedHours" class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Budgeted Hours*</i></b>: {{chart.budgetedHours}}</span>
              <span v-if="chart.salary" class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Salary*</i></b>: ${{chart.salary}}</span>
          </v-flex>
          <v-btn v-if="chart.reports && chart.reports.length && !isMoveInProgessSelected"  width="50" height="50" style="position: absolute; bottom:-25px; left: calc(50% - 25px); z-index:101" icon @click.stop="toggleExpand">
            <v-icon v-show="expanded">fas fa-minus-circle</v-icon>
            <v-icon v-show="!expanded">fas fa-plus-circle</v-icon>
          </v-btn>
      </v-card>
      <!-- <v-card :style="{'height': orgCardHeight + 'px', 'width': '30px', 'left': `${parentLeftOffset}px` }" class="clickToMove">
        <v-layout justify-center align-center fill-height>
          <v-icon>fas fa-arrow-right</v-icon>
        </v-layout>
      </v-card>
      <v-card :style="{'height': orgCardHeight + 'px', 'width': '30px', 'left': `${parentLeftOffset - orgCardWidth - 60}px` }" class="clickToMove justify-center align-center">
        <v-layout justify-center align-center fill-height>
          <v-icon>fas fa-arrow-left</v-icon>
        </v-layout>
      </v-card> -->
      <v-card v-if="moveInProgress && !isMoveInProgessSelected && !parentMoving" :style="{'position': 'absolute', 'height': '50px', 'width': `${orgCardWidth}px`, 'left': `${parentLeftOffset}px`, 'top': `${orgCardHeight}px`, 'z-index': '100' }" class="clickToMove justify-center align-center elevation-12" @click.stop="selectMoveDestination">
        <v-layout justify-center align-center fill-height>
          <v-icon color="black">fas fa-arrow-down</v-icon>
        </v-layout>
      </v-card>
  <v-flex v-if="chart.reports && chart.reports.length" v-for="(report, i) in orderedReports" :key="i + chart.reportsHorizontal" :style="{'animation': '.1s fadein', 'position': 'absolute', 'min-width': '100%', 'left': `${chart.reportsHorizontal ? report.offsetX : parentLeftOffset}px`, 'top': `${chart.reportsHorizontal ? childTop : report.offsetY}px`}">
    <v-flex :class="{ 'row': chart.reportsHorizontal, 'column': !chart.reportsHorizontal}" v-show="expanded" v-if="chart.reports && chart.reports.length > 0" :style="{'position': 'absolute'}">
      <ChartBox2 class="" ref="child" :panzoomInstance=panzoomInstance :currentX=currentX :currentY=currentY :scale=1 :whichPageToShow=whichPageToShow :mappingScale=mappingScale :key="id + i + 1" :chart=report :redrawAllLines=redrawAllLines :id="id + i + 1" :top="0" :left="0" :chartUUID=chartUUID :indexArray="[...indexArray, i]" :functions=functions :moveInProgress=moveInProgress :parentMoving="isMoveInProgessSelected || parentMoving"
      :style="{'min-width': `${report.bumperX}px`, 'width': `100%`, 'min-height': `${report.bumperY}px`, 'left': `${0}px`, 'position': 'absolute'}">
      </ChartBox2>
    </v-flex>
  </v-flex>
</v-layout>
</v-layout>
  <!-- <v-layout ref="wrapper" :style="{'clear': 'both', 'position': 'relative', 'margin-left': 'auto', 'margin-right': 'auto'}">
    <svg v-show="expanded" v-if="chart.reports && chart.reports.length > 0" id="lines" :ref="'lines' + id" 
        v-bind:style="{'position': 'absolute', 'min-width': `${(maxLinePointWidth + 200) * (1 / whichPageToShow)}px`, 'min-height': `${(maxLinePointHeight + 200) * (1 / whichPageToShow)}px`}"> </svg>
    <v-flex :style="{'position': 'relative', 'min-width': `${minWidth ? minWidth : 400}px`}" ref="firstChild">
      <v-flex v-show="expanded" column justify-center>
      <v-card v-if="whichPageToShow >= 0.75" :style="{'height': orgCardHeight + 'px', 'width': this.orgCardWidth + 'px', 'left': this.ignoreMargin ? '0%' : `50%`}" class="org-chart-user justify-center"  justify-center ref='main'>
      <v-card-title :style="{'background-color': (chart.department === 'Engineering' ? 'rgba(200,0,0,0.2)' : (chart.department === 'Operations' ? 'rgba(0,0,200,0.2)' : (chart.department === 'Marketing' ? 'rgba(211, 84, 0, 0.2)' : 'rgba(249, 191, 59, 1)'))), 'margin-bottom':'20px'}" class="justify-space-between">
        <v-avatar size="100" class="elevation-20" style="position: absolute; top:-75px; left: calc(50% - 50px); z-index:100">
          <v-img
          
          :src="chart.person ? chart.person.imageUrl : require('../assets/OpenPosition.jpg')"
          ></v-img>
        </v-avatar>
        <span  class="caption" style="position:absolute; right:10px; bottom:10px"><i>* indicates a custom field is only visible to administrators</i></span>
        <v-flex  column>
          <span v-if="chart.person"  class="title" style="display:block; margin-top:20px">{{chart.person.firstName}} {{chart.person.lastName}}</span>
            <span v-else  class="title" style="display:block; margin-top:20px">Open Position</span>
          <v-divider  />
          <span  class="subtitle-1">{{chart.jobTitle}}</span>
        </v-flex>
      </v-card-title>
       <v-flex  column justify-center style="max-height: 90%;">
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Department</b>: {{chart.department}}</span>
            <span  v-if="chart.person"  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Hire Date</b>: {{chart.person.hireDate ? chart.person.hireDate.toLocaleDateString("en-US") : new Date(Math.random() * new Date().getTime()).toDateString()}}</span>
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Budgeted Hours*</i></b>: {{chart.budgetedHours}}</span>
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Salary*</i></b>: ${{chart.salary}}</span>
        </v-flex>
        <v-btn v-if="chart.reports && chart.reports.length"  width="50" height="50" style="position: absolute; bottom:-25px; left: calc(50% - 25px); z-index:100" icon @click="toggleExpand">
          <v-icon v-show="expanded">fas fa-minus-circle</v-icon>
          <v-icon v-show="!expanded">fas fa-plus-circle</v-icon>
        </v-btn>
    </v-card>
    <v-card v-else :style="{'height': orgCardHeight + 'px', 'width': this.orgCardWidth + 'px', 'left': this.ignoreMargin ? '0%' : `50%`}" class="org-chart-user justify-center"  justify-center ref='main'>
    <v-card-title  :style="{'height': '100%', 'background-color': (chart.department === 'Engineering' ? 'rgba(200,0,0,0.2)' : (chart.department === 'Operations' ? 'rgba(0,0,200,0.2)' : (chart.department === 'Marketing' ? 'rgba(211, 84, 0, 0.2)' : 'rgba(249, 191, 59, 1)')))}" class="justify-space-between">
      <v-avatar  size="150" class="elevation-20" style="position: absolute; top:-75px; left: calc(50% - 75px); z-index:100">
        <v-img
        
        :src="chart.person ? chart.person.imageUrl : require('../assets/OpenPosition.jpg')"
        ></v-img>
      </v-avatar>
      <v-flex  column>
        <span v-if="chart.person"  class="display-2" style="display:block; margin-top:50px">{{chart.person.firstName}} {{chart.person.lastName}}</span>
          <span v-else  class="display-2" style="display:block; margin-top:50px">Open Position</span>
        <v-divider v-if="whichPageToShow >= 0.45" />
        <span  v-if="whichPageToShow >= 0.45" class="headline">{{chart.jobTitle}}</span>
      </v-flex>
    </v-card-title>
    <v-btn v-if="chart.reports && chart.reports.length"  width="100" height="100" style="position: absolute; bottom:-50px; left: calc(50% - 50px); z-index:100" icon @click="toggleExpand">
      <v-icon size="50" v-show="expanded">fas fa-minus-circle</v-icon>
      <v-icon size="50" v-show="!expanded">fas fa-plus-circle</v-icon>
    </v-btn>
    </v-card>
    <v-flex :class="{ 'row': chart.reportsHorizontal, 'column': !chart.reportsHorizontal}" v-show="expanded" v-if="chart.reports && chart.reports.length > 0" :style="{'margin-top': `${orgCardHeight / 2}px`, 'flex-wrap': 'nowrap', 'width': '100%'}">
      <ChartBox ref="child" :panzoomInstance=panzoomInstance :currentX=currentX :currentY=currentY :scale=1 :whichPageToShow=whichPageToShow :mappingScale=mappingScale :key=j v-for="(report, j) in orderedReports" :chart=report :id="id + j + 1"
      :style="{'min-width': `${report.reportsHorizontal ? (report.reports.length + 1) * 600 : 600}px`, 'width': `100%`, 'min-height': `${orgCardHeight}px`, 'margin-left': `${(orgCardWidth / 4)}px`, 'margin-top': `${orgCardHeight / 3}px`}">
        </ChartBox>
    </v-flex>
    </v-flex>
    </v-flex>
  </v-layout> -->
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import ChartBox2 from './ChartBox2';
import * as _ from 'lodash';
export default {
    props: ['chart', 'id', 'ignoreMargin', 'scale', 'mappingScale', 'whichPageToShow', 'currentX', 'currentY', 'panzoomInstance', 'top', 'left', 'redrawAllLines', 'chartUUID', 'indexArray', 'functions', 'moveInProgress', 'parentMoving'],
    name: 'ChartBox2',
    mounted() {
      // this.zoomToMain()
      window.setTimeout(() => {this.drawLines()}, 700)
      // window.setInterval(() => {
      //  this.magicDistance = this.magicDistance + 1
      // },1000);
    },
    components: {ChartBox2},
    directives: {
      'dragscroll': dragscroll
    },
    data: function() {
      return {
        reportsUpdatedCount: 0,
        count: 1,
        objs: [
          {width: '500px'}
          ],
        expanded: this.chart.expanded || !this.id,
        maxLinePointWidth: 0,
        maxLinePointHeight: 0,
        minWidth: 0,
        childrenWidthMin: Number.MAX_SAFE_INTEGER,
        childrenWidthMax: Number.MIN_SAFE_INTEGER,
        childrenHeightMin: Number.MAX_SAFE_INTEGER,
        childrenHeightMax: Number.MIN_SAFE_INTEGER,
      }
    },
    computed: {
      parentMinWidth: function() {
        if (this.id === 0) {
          return this.orderedReports.map((report) => report.bumperX).reduce(((a,b) => a + b), 0)
        }
        return 0
      },
      parentMinHeight: function() {
        if (this.id === 0) {
          return this.orderedReports.map((report) => report.bumperY).reduce(((a,b) => a + b), 0)
        }
        return 0
      },
      isMoveInProgessSelected: function () {
        if (this.moveInProgress) {
          return _.isEqual(this.moveInProgress, this.indexArray)
        }
        return false
      },
      orgCardWidth: function () {
        return 500
      },
      orgCardHeight: function () {
        return 250
      },
      magicDistance: function () {
        return this.orgCardWidth * 1.5;
      },
      childTop: function() {
        let topOffset = this.top + this.orgCardHeight + 200;
        return topOffset;
      },
      orderedReports: function() {
        this.reportsUpdatedCount;
        if (this.chart.reports) {
        let sortedReports = this.chart.reports;
        let lastOffsetX = this.left;
        let lastOffsetY = this.childTop;
        let orderedWithBumpers = sortedReports.map(report => {
          report.reportsHorizontal;
          let offsetX = lastOffsetX;
          let offsetY = lastOffsetY
          let {widthSum, heightSum} = this.getReportDimTotals(report, false)
          let bumperX = widthSum
          let bumperY = heightSum
          lastOffsetX = offsetX + widthSum;
          lastOffsetY = offsetY + heightSum;
          return {
            ...report,
            bumperX,
            bumperY,
            offsetX,
            offsetY,
          }
        })
        // console.log(orderedWithBumpers)
        return orderedWithBumpers
        }
        return []
      },
      parentLeftOffset: function() {
        // Some magic equation here... please help me
        let length = this.orderedReports.length
        if (length > 0) {
          if (length === 1) {
            return 0;
          }
          else {
            // console.log('=======')
            // console.log(this.chart)
            // console.log(this.orderedReports)
            // console.log('=======')
            let totalWidth = 0;
            this.orderedReports.forEach(report => {
              totalWidth += report.offsetX;
              if (report.reports && report.reports.length > 1) {
                totalWidth += (report.bumperX / 2);
              }
            })
            return (totalWidth / length);
          } 
        } else {
          return 0;
        }
      }
    },
    watch: {
      chart: function() {
        window.setTimeout(() => {this.drawLines()}, 500)
      },
    },
    methods: {
      cardClicked: function() {
        this.functions.setSelectedCard(this.indexArray)
      },
      incrementReportsUpdatedCount: function() {
        this.reportsUpdatedCount++;
      },
      toggleHorizontal: function () {
        this.expanded = false;
        this.functions.toggleHorizontal(this.indexArray);
        this.expanded = true;
        
        if (this.chart.expanded != this.expanded) {
          this.functions.setExpanded(this.indexArray, this.expanded)
        }
      },
      toggleMove: function () {
        this.expanded = true;
        if (this.chart.expanded != this.expanded) {
          this.functions.setExpanded(this.indexArray, this.expanded)
        }        
        this.functions.toggleMove(this.indexArray);
      },
      selectMoveDestination: function () {
        this.functions.selectMoveDestination(this.indexArray);
        this.expanded = true;
        if (this.chart.expanded != this.expanded) {
          this.functions.setExpanded(this.indexArray, this.expanded)
        }
        this.redrawAllLines()
      },
      addReport: function () {
        this.expanded = false;
        this.functions.addReport(this.indexArray);
        this.expanded = true;
        if (this.chart.expanded != this.expanded) {
          this.functions.setExpanded(this.indexArray, this.expanded)
        }
        this.redrawAllLines()
      },
      previousHeight: function(index) {
        if (this.orderedReports && this.orderedReports.length > (index - 1) && this.orderedReports[index - 1].bumperY) {
          return this.orderedReports[index - 1].bumperY
        }
        return 0;
      },
      getReportDimTotals: function (report, isHortizontal) {
        let horizontalSpacer = 50;
        let verticalSpacer = 10;
        let widthSum = this.orgCardWidth + horizontalSpacer;
        let heightSum = this.orgCardHeight + verticalSpacer;
        if (isHortizontal) {
          widthSum += this.orgCardWidth + horizontalSpacer;
          heightSum = this.orgCardHeight + verticalSpacer;
        } else {
          widthSum = this.orgCardWidth + horizontalSpacer;
          heightSum += this.orgCardHeight + verticalSpacer;          
        }
        report.reports.forEach((childReport) => {
          let childSums = this.getReportDimTotals(childReport, false)
            heightSum += childSums.heightSum;
            widthSum += childSums.widthSum;
        })
      
        return {widthSum, heightSum}
      },
      getWidth: function() {
        return 400;
      },
      toggleExpand: function() {
        this.expanded = !this.expanded
        if (this.chart.expanded != this.expanded) {
          this.functions.setExpanded(this.indexArray, this.expanded)
        }
        this.redrawAllLines()
        // setTimeout(this.drawLines, 1)
      },
      getMainBoundingBox: function() {
        return this.$refs.main.$el.getBoundingClientRect()
      },
      rotate: function() {

      },
      zoomToMain: function() {
        var mainBoundingBox = this.getMainBoundingBox()
        var deltaX = mainBoundingBox.right - mainBoundingBox.left;
        var deltaY = mainBoundingBox.bottom;
        this.panzoomInstance.smoothZoom(deltaX * -1.75, deltaY * 0.2, this.$vuetify.breakpoint.smAndDown ? 0.2 : 0.3);
        // setTimeout(this.drawLines,700)
      },
      drawLines: function(resetMinWidth = false) {
        let maxWidth = []
        let maxHeight = []
        let minWidth = []
        let minHeight = []
        var svgComponent = this.$refs['lines' + this.id]
        let wrapperBoundingBox = this.$refs.wrapper.getBoundingClientRect()
        var parentBoundingBox = this.$refs.main.$el.getBoundingClientRect()
        if (svgComponent) {
        while (svgComponent.firstChild) {
          svgComponent.removeChild(svgComponent.firstChild);
        }
        var multiplier = 1 / this.whichPageToShow
        var svgBoundingBox = svgComponent.getBoundingClientRect()
        var parentCenterWidth = (parentBoundingBox.left + ((parentBoundingBox.width) / 2)) - svgBoundingBox.left
        var parentCenterHeight = parentBoundingBox.top - svgBoundingBox.top
        maxWidth.push(parentBoundingBox.right + parentBoundingBox.x)
        maxHeight.push(parentBoundingBox.bottom + parentBoundingBox.y)
        minWidth.push(parentBoundingBox.left + parentBoundingBox.x)
        minHeight.push(parentBoundingBox.top + parentBoundingBox.y)
        var childrenBoundingBox = this.$refs['child']
        let maxXPositions = childrenBoundingBox.map(xy => xy.drawLines()).filter(x => !!x)
        for (var i = 0; i < childrenBoundingBox.length; i ++) {
          var childBox = childrenBoundingBox[i]
          var childBoundingBox = childBox.getMainBoundingBox()
          maxXPositions.push(childBoundingBox.right)
          var newpath = document.createElementNS('http://www.w3.org/2000/svg',"path");  
          var childCenterWidth = (childBoundingBox.left + (childBoundingBox.width / 2)) - svgBoundingBox.left
          var childCenterHeight = childBoundingBox.top - svgBoundingBox.top
          maxWidth.push(childBoundingBox.right - wrapperBoundingBox.left + parentBoundingBox.width)
          maxHeight.push(childBoundingBox.bottom - wrapperBoundingBox.top)
          minWidth.push(childBoundingBox.right - wrapperBoundingBox.left)
          minHeight.push(childBoundingBox.bottom - wrapperBoundingBox.top)
          let mappedWidthPoints = []
          let mappedHeightPoints = []
        if (this.chart.reportsHorizontal) {
          mappedWidthPoints.push(parentCenterWidth, childCenterWidth)
          mappedHeightPoints.push(parentCenterHeight, (parentCenterHeight + parentBoundingBox.height * 1.3), childCenterHeight)
          newpath.setAttributeNS(null, "d", `M${parentCenterWidth * multiplier} ${parentCenterHeight * multiplier} L${parentCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.3) * multiplier} L${childCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.3) * multiplier} L${childCenterWidth * multiplier} ${childCenterHeight * multiplier}`);
        } else {
            mappedWidthPoints.push(parentCenterWidth, (childCenterWidth + parentBoundingBox.width / 1.5), childCenterWidth)
            mappedHeightPoints.push(parentCenterHeight, (parentCenterHeight + parentBoundingBox.height * 1.15), childCenterHeight, (childCenterHeight + parentBoundingBox.height / 2))
            newpath.setAttributeNS(null, "d", `M${parentCenterWidth * multiplier} ${parentCenterHeight * multiplier} L${parentCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.15) * multiplier} L${(childCenterWidth + parentBoundingBox.width / 1.5) * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.15) * multiplier} L${(childCenterWidth + parentBoundingBox.width / 1.5) * multiplier} ${(childCenterHeight + parentBoundingBox.height / 2) * multiplier} L${childCenterWidth * multiplier} ${(childCenterHeight + parentBoundingBox.height / 2) * multiplier}`);
        }
          newpath.setAttribute("stroke-width", `${3 /** multiplier FOR THICKNESS*/}`)
          newpath.setAttribute("fill", "none")
          newpath.setAttribute("stroke", `rgba(200,200,200, 1)`)
          //newpath.setAttribute("stroke", `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.8)`)
          //newpath.setAttribute("stroke-dasharray", "4")
          svgComponent.appendChild(newpath)
          this.childrenWidthMin = this.childrenWidthMin > Math.min(mappedWidthPoints) ? Math.min(mappedWidthPoints) : this.childrenWidthMin
          this.childrenWidthMax = this.childrenWidthMax < Math.max(mappedWidthPoints) ? Math.max(mappedWidthPoints) : this.childrenWidthMin
          this.childrenHeightMin = this.childrenHeightMin > Math.min(mappedHeightPoints) ? Math.min(mappedHeightPoints) : this.childrenHeightMin
          this.childrenHeightMax = this.childrenHeightMax < Math.max(mappedHeightPoints) ? Math.max(mappedHeightPoints) : this.childrenHeightMin
        }
        this.maxLinePointWidth = Math.max(...maxWidth)
        this.maxLinePointHeight = Math.max(...maxHeight)
        this.minLinePointWidth = Math.min(...minWidth)
        this.minLinePointHeight = Math.min(...minHeight)
        if (this.minWidth === 0 || resetMinWidth) {
          this.minWidth = (Math.max(...maxXPositions) - svgBoundingBox.left + 50 * (0.1 / this.whichPageToShow)) * (this.id === 0 ? (multiplier / 1.1) : 1)
          setTimeout(this.drawLines, 1)
          if (this.id === 0 && !resetMinWidth) {
            setTimeout(this.zoomToMain, 500)
          }
        }
        return Math.max(...maxXPositions)
      }
      }
    }
}
</script>

<style lang="scss">
@keyframes fadein {
    from { opacity: 0; left: 100px; }
    to { opacity: 1; left: 0px; }
}
</style>
